const loadScriptService = function (options) {
    if (!arguments.length || options.constructor !== Object) {
        throw new Error('Invalid or missing options argument');
    }

    if (!options.url || options.url.constructor !== String) {
        throw new Error('window.tbg.loadScript: Invalid or missing required parameter "url" of options argument');
    }

    var completeCallback = options.callback && options.callback.constructor === Function ? options.callback : noop;
    var attributes = options.attrs && options.attrs.constructor === Object ? options.attrs : {};
    var script = document.createElement('script');
    script.type = 'text/javascript';
    options.delay = options.delay || 0;

    for (var attr in attributes) {
        if (attributes.hasOwnProperty(attr)) {
            script.setAttribute(attr, attributes[attr]);
        }
    }

    // For IE
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                completeCallback();
            }
        };
    // For non-IE
    } else {
        script.onload = function () {
            completeCallback();
        };
    }

    window.setTimeout(getScript, options.delay);

    return;

    function getScript () {
        script.src = options.url;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    function noop(){}
};
export default loadScriptService;